import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/authContext';
import { LocalizationProvider } from './contexts/localizationContext';
import IntlWrapper from './features/localization/components/IntlWrapper';
import Router from './features/routing/components/Router';
import { SnackbarProvider } from 'notistack';
import ThemeConfig from './theme';
import DateLocalization from './components/DateLocalization';


export default function App() {
  return (
    <LocalizationProvider>
      <DateLocalization>
        <ThemeConfig>
          <IntlWrapper>
            <AuthProvider>
              <BrowserRouter>
                <SnackbarProvider maxSnack={3} autoHideDuration={2000}>
                  <Router />
                </SnackbarProvider>
              </BrowserRouter>
            </AuthProvider>
          </IntlWrapper>
        </ThemeConfig>
      </DateLocalization>
    </LocalizationProvider>
  );
}